var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "230px",
    height: "230px",
    viewBox: "0 0 230 230",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-87.000000, -44.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-_havaqovi",
    transform: "translate(87.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 230,
    height: 230
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.7199,193.71 L156.7699,196.05 C154.0999,202.59 147.7299,206.87 140.6499,206.87 L109.5899,206.87 L114.8899,193.71 L157.7199,193.71 Z",
    id: 1,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 2,
    fill: "#FFD426",
    points: "93.5197 193.71 88.1097 206.87 58.1697 206.87 63.4697 193.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 3,
    fill: "#FFD426",
    points: "63.4699 193.71 58.1699 206.87 14.9999 206.87 20.2999 193.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 4,
    fill: "#FFD426",
    points: "68.6896 180.7403 63.4696 193.7103 20.2996 193.7103 25.5306 180.7403"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 5,
    fill: "#FFD426",
    points: "98.8498 180.7403 93.5198 193.7103 63.4698 193.7103 68.6898 180.7403"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 6,
    fill: "#FFD426",
    points: "163.0099 180.7403 157.7199 193.7103 114.8899 193.7103 120.1199 180.7403"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 7,
    fill: "#FFD426",
    points: "168.7502 166.6505 163.0102 180.7405 120.1202 180.7405 125.7902 166.6505"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 8,
    fill: "#FFD426",
    points: "104.6301 166.6602 98.8501 180.7402 68.6901 180.7402 74.3701 166.6502 74.4001 166.6502 74.4001 166.6602"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 9,
    fill: "#FFD426",
    points: "74.3703 166.6505 68.6893 180.7405 25.5303 180.7405 31.2003 166.6505"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 10,
    fill: "#FFD426",
    points: "80.1203 152.3702 76.3993 161.5902 74.3993 166.6502 31.2003 166.6502 36.9603 152.3702"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 11,
    fill: "#FFD426",
    points: "174.5705 152.3702 168.7505 166.6502 125.7905 166.6502 131.5405 152.3702"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 12,
    fill: "#FFD426",
    points: "180.3898 138.0899 174.5708 152.3699 131.5398 152.3699 133.3498 147.8799 137.2898 138.0899"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 13,
    fill: "#FFD426",
    points: "137.2902 138.0899 133.3502 147.8799 81.9302 147.8799 85.8702 138.0899"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 14,
    fill: "#FFD426",
    points: "85.8703 138.0899 81.9303 147.8799 80.1203 152.3699 36.9603 152.3699 39.0993 147.0499 39.2293 146.7299 42.7103 138.0899"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 15,
    fill: "#FFD426",
    points: "92.09 122.6505 85.87 138.0895 42.71 138.0895 48.93 122.6505"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 16,
    fill: "#FFD426",
    points: "143.5099 122.6505 137.2899 138.0895 85.8699 138.0895 92.0899 122.6505"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 17,
    fill: "#FFD426",
    points: "186.6896 122.6505 180.3896 138.0895 137.2906 138.0895 143.5096 122.6505"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 18,
    fill: "#FFD426",
    points: "192.7101 107.8702 186.6891 122.6502 143.5101 122.6502 149.4601 107.8702"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 19,
    fill: "#FFD426",
    points: "149.4601 107.8702 143.5101 122.6502 92.0901 122.6502 98.0401 107.8702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0402,107.8702 L92.0902,122.6502 L49.0502,122.6502 L50.6602,118.6892 C53.3302,112.1502 59.7002,107.8702 66.7802,107.8702 L98.0402,107.8702 Z",
    id: 20,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 21,
    fill: "#232D35",
    points: "223.6506 97.0299 153.9296 96.7699 102.5806 96.5899 59.4906 96.4299 21.6296 96.2899 71.7106 66.0899 80.1206 61.0199 80.1206 40.9299 96.5096 40.9299 96.5096 51.1499 136.6206 26.9999"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.327ce704ed07662019e3f30694d5c95b.svg";
export { ForwardRef as ReactComponent };